import { getJson, postJson } from './client'
import type { Methodology, MethodologyDetail, TacticApplication } from '../types/methodology'
import type { JobView } from '../types/voice'

// The playbook surface: methodologies, their tactics as a workflow, and how they are applied and measured.
const base = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/methodologies`

export const methodologyApi = {
  list: (spoke: string) => getJson<Methodology[]>(base(spoke)),
  get: (spoke: string, id: string) => getJson<MethodologyDetail>(`${base(spoke)}/${encodeURIComponent(id)}`),
  ingest: (spoke: string, name: string, documentPath: string) => postJson<JobView>(`${base(spoke)}/ingest`, { name, documentPath }),
  apply: (spoke: string, id: string, tacticId: string, body: { engagementId?: string; personId?: string; status: string; outcome?: string; note?: string }) =>
    postJson<TacticApplication>(`${base(spoke)}/${encodeURIComponent(id)}/tactics/${encodeURIComponent(tacticId)}/apply`, body),
  applications: (spoke: string, id: string, engagementId?: string) =>
    getJson<TacticApplication[]>(`${base(spoke)}/${encodeURIComponent(id)}/applications`, engagementId ? { engagementId } : undefined),
}
